import { PropType, defineComponent, computed } from 'vue'
import { Store } from 'pinia'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import SoInformation from './soInformation'
import InformationV2 from './informationV2'
// import Information from './information'

export default defineComponent({
  name: 'information-comps',
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const componentStore = computed(() => props.componentStore)

    return () => (
      <>
        {componentStore.value.showSummary &&
          componentsConfig?.data_default?.show &&
          window.client !== 'mobile' && (
            <>
              {componentsConfig?.data_default?.properties?.type === 'somap' ? (
                <SoInformation></SoInformation>
              ) : (
                <>
                  <InformationV2></InformationV2>
                  {/* {(process.config as any).brand === 'alps' ||
                  (process.config as any).brand === 'fy' ? (
                    <InformationV2></InformationV2>
                  ) : (
                    <Information></Information>
                  )} */}
                </>
              )}
            </>
          )}
      </>
    )
  },
})
